import { HTTP_TYPES } from '@/lib/enums';
import api from '@/api/api';
import { PLATFORM_HEADERS } from './platform';
import type { ReportDefinition } from '@/stores/onetwofive/reports.store';

// ponytail: base URL is a stub until the real Public/Internal API host is confirmed.
const BASE = import.meta.env.VITE_125_PLATFORM_PUBLIC_BASE_URL;

const response = {
	// GET /reports/builder/catalogue: internal, cross-tenant. `company_id` is optional
	// and only ever ADDS dimensions (that company's branch attributes), so it is omitted
	// entirely rather than sent empty when describing the company-independent surface.
	async getCatalogue(companyId?: string | number | null): Promise<any> {
		const params =
			companyId === undefined || companyId === null || companyId === ''
				? undefined
				: { company_id: String(companyId) };

		return await api(
			HTTP_TYPES.GET,
			`${BASE}/reports/builder/catalogue`,
			undefined,
			params,
			'application/json',
			'v1',
			{ ...PLATFORM_HEADERS },
		);
	},

	// POST /reports/builder/query: internal, cross-tenant. A POST is used for a read
	// because the definition is a nested object that will not fit a query string, so
	// `company_id` travels in the body and NO tenant header is sent.
	//
	// ponytail: no `format=csv` support. The 200 response already carries the column
	// labels the CSV would use, so the client builds the file from a result it holds
	// rather than paying for a second execution of the same query.
	async postQuery(definition: ReportDefinition): Promise<any> {
		return await api(
			HTTP_TYPES.POST,
			`${BASE}/reports/builder/query`,
			definition,
			undefined,
			'application/json',
			'v1',
			{ ...PLATFORM_HEADERS },
		);
	},
};

export default response;
